import { useMemo } from 'react';

import { PickersDayProps } from '@mui/x-date-pickers';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { setMonth } from 'date-fns';
import { Colors } from 'libs/ui/theme';

import { ColoredDates } from '../types';

import { PickersDay } from './PickersDay';

const EmptyComponent = () => null;

export interface CalendarMonthProps {
  currentDate: Date;
  monthNumber: number;
  coloredDates: ColoredDates;
  readOnly?: boolean;
  onClickDay?: (value: Date | null) => void;
  disablePast?: boolean;
}

export const CalendarMonth = ({
  currentDate,
  monthNumber,
  coloredDates,
  readOnly,
  onClickDay,
  disablePast,
}: CalendarMonthProps) => {
  const referenceDate = useMemo(
    () => setMonth(currentDate, monthNumber),
    [currentDate, monthNumber]
  );

  const pickersDayWrapper = (props: PickersDayProps) => (
    <PickersDay {...props} readOnly={readOnly} />
  );

  return (
    <DateCalendar
      disableHighlightToday
      disablePast={disablePast}
      readOnly={readOnly}
      referenceDate={referenceDate}
      slotProps={{
        day: {
          coloredDates,
        } as any,
      }}
      slots={{
        day: pickersDayWrapper,
        nextIconButton: EmptyComponent,
        leftArrowIcon: EmptyComponent,
      }}
      sx={{
        width: '100%',
        margin: 0,
        maxWidth: 428,
        minWidth: 300,
        height: 'auto',
        textTransform: 'capitalize',
        '.MuiPickersCalendarHeader-root': {
          padding: 0,
          marginTop: 0,
          marginBottom: '12px',
          minHeight: 26,
        },
        '.MuiPickersCalendarHeader-label': {
          fontWeight: 600,
          fontSize: 20,
          lineHeight: '130%',
        },
        '.MuiDayCalendar-weekDayLabel': {
          fontSize: 16,
          color: Colors.gray600,
          fontWeight: 500,
        },
        '.MuiDayCalendar-header, .MuiDayCalendar-weekContainer': {
          justifyContent: 'space-between',
        },
        '.MuiPickersCalendarHeader-labelContainer': { cursor: 'default' },
      }}
      value={null}
      views={['day']}
      onChange={onClickDay}
    />
  );
};
